<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator />
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white  cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col>
                <el-row>
                  <el-col :span="8">
                    <span class="cs-title">签到查询</span>
                  </el-col>
                  <el-col :span="16" style="text-align: right;">
                    <div class="cs-content-group">
                      <el-button v-if="activeQueryType == '1'" type="primary" size="medium" v-loading="isSaveStudentCourseAttendanceHistoryForAll"
                        @click="onSaveAttendanceClick">提取出勤率</el-button>
                      <el-button type="primary" size="medium" :loading="isExporting" @click="onExportClick">导出</el-button>
                    </div>
                  </el-col>
                </el-row>

                <el-tabs v-model="activeQueryType" type="card">
                  <el-tab-pane name="1" v-if="hasTab1">
                    <span slot="label">签到查询 (学生)</span>
                    <el-row class="grid-content">
                      <el-col>
                        <signInQueryList1 key="signInQueryList1" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :queryType="activeQueryType"
                          :scPreloadData="searchConditionPreloadData" :paginationOption="paginationOption" />
                      </el-col>
                    </el-row>
                  </el-tab-pane>
                  <el-tab-pane name="2" v-if="hasTab2">
                    <span slot="label">签到查询 (课程)</span>
                    <el-row class="grid-content">
                      <el-col>
                        <signInQueryList2 key="signInQueryList2" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :queryType="activeQueryType"
                          :scPreloadData="searchConditionPreloadData" :paginationOption="paginationOption" />
                      </el-col>
                    </el-row>
                  </el-tab-pane>
                  <el-tab-pane name="3" v-if="hasTab3">
                    <span slot="label">签到查询 (老师)</span>
                    <el-row class="grid-content">
                      <el-col>
                        <signInQueryList3 key="signInQueryList3" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :queryType="activeQueryType"
                          :scPreloadData="searchConditionPreloadData" :paginationOption="paginationOption" />
                      </el-col>
                    </el-row>
                  </el-tab-pane>
                  <el-tab-pane name="4" v-if="hasTab4">
                    <span slot="label">监课查询 (课程)</span>
                    <el-row class="grid-content">
                      <el-col>
                        <signInQueryList4 key="signInQueryList4" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :queryType="activeQueryType"
                          :scPreloadData="searchConditionPreloadData" :paginationOption="tabPaginationOption4" />
                      </el-col>
                    </el-row>
                  </el-tab-pane>
                </el-tabs>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import navigator from "@/components/navigator";
import signInQueryList1 from "@/components/signInManage/signInQueryList1";
import signInQueryList2 from "@/components/signInManage/signInQueryList2";
import signInQueryList3 from "@/components/signInManage/signInQueryList3";
import signInQueryList4 from "@/components/signInManage/signInQueryList4";

import {
  getUniversityGroups,
  getTerms,
  getTrainingCategoryList,
} from "@/service/common.service";
import { saveStudentCourseAttendanceHistoryForAll } from "@/service/signInManage.service";

import { mixinSignInQuery } from "@/components/signInManage/mixinSignInQuery";

export default {
  name: "signInQuery",
  mixins: [mixinSignInQuery],
  provide() {
    let provideObj = {
      getRef: this.$vueRefStore.getRef,
      getChildrenRef: this.$vueRefStore.getChildrenRef,
    };

    return provideObj;
  },
  data() {
    return {
      isSaveStudentCourseAttendanceHistoryForAll: false,
      isExporting: false,
      loading: false,
      activeQueryType: null,
      searchConditionPreloadData: {
        defaultValues: {
          termId: null,
          groupNumber: null,
          trainingCourseCategory: null,
        },
        courseTypeItems: [],
        termList: [],
        universityGroups: [],
        trainingCourseCategories: [],
      },
      paginationOption: {
        displayPagination: false,
        hasEditButton: false,
        editButtonText: String.empty,
        hasAddButton: false,
        addButtonText: String.empty,
        hasSearch: false,
        editColumnTite: String.empty,
        showAcitveColor: true,
        hideDisableRow: true,
      },
      tabPaginationOption4: {
        displayPagination: true,
        hasEditButton: false,
        editButtonText: String.empty,
        hasAddButton: false,
        addButtonText: String.empty,
        hasSearch: false,
        editColumnTite: String.empty,
        showAcitveColor: true,
        hideDisableRow: true,
      },
    };
  },
  components: {
    navigator,
    signInQueryList1,
    signInQueryList2,
    signInQueryList3,
    signInQueryList4,
  },
  created() {
    this.resetActiveQueryType();

    this.$nextTick(async () => {
      this.searchConditionPreloadData =
        await this.loadSearchConditionPreloadData();
    });
  },
  computed: {
    hasTab1() {
      return (
        this.USERMANAGER.isAdmin ||
        this.USERMANAGER.isFrontDesk ||
        this.USERMANAGER.isVocationalTrainingManager
      );
    },
    hasTab2() {
      return (
        this.USERMANAGER.isAdmin ||
        this.USERMANAGER.isEducationalAssistant ||
        this.USERMANAGER.isAcademicDirector ||
        this.USERMANAGER.isVocationalTrainingManager
      );
    },
    hasTab3() {
      //隐藏签到查询(老师)Tab
      return true;

      // return  this.hasTab2;
    },
    hasTab4() {
      return (
        this.USERMANAGER.isAdmin ||
        this.USERMANAGER.isPersonnelManagement ||
        this.USERMANAGER.isAcademicDirector ||
        this.USERMANAGER.isCampusPresident
      );
    },
  },
  methods: {
    async loadSearchConditionPreloadData() {
      let defaultValues = {
        courseType: null,
        termId: null,
        groupNumber: null,
        trainingCourseCategory: null,
      };

      let exceptCourseTypes = [
        this.GLOBAL.courseType.none,
        this.GLOBAL.courseType.english,
        this.GLOBAL.courseType.newStudentGuide,
      ];
      if (this.USERMANAGER.isVocationalTrainingManager) {
        exceptCourseTypes.push(this.GLOBAL.courseType.university);
      }
      let courseTypeItems = Object.clone(this.GLOBAL.courseType.getOptions());
      courseTypeItems = courseTypeItems.filter(
        (item) => !exceptCourseTypes.contains(item.value)
      );
      let currentCourseTypeItem = null;
      if (courseTypeItems.length > 0) {
        currentCourseTypeItem = courseTypeItems[0];
      }
      defaultValues.courseType = currentCourseTypeItem.value;

      let result = await getTerms(false);
      let termList = !!result && result.success ? result.data : [];
      let currentTerm = null;
      if (termList.length > 0) {
        currentTerm = result.data.find((i) => i.IsCurrentTerm);
        if (!currentTerm) currentTerm = termList[0];
      }
      defaultValues.termId = !!currentTerm ? currentTerm.Id : null;

      result = await getUniversityGroups();
      let universityGroups = !!result && result.success ? result.data : [];
      let currentGroup = null;
      if (universityGroups.length > 0) {
        currentGroup = universityGroups[0];
      }
      defaultValues.groupNumber = !!currentGroup
        ? currentGroup.GroupNumber
        : null;

      result = await getTrainingCategoryList(
        this.GLOBAL.courseType.vocationalTraining
      );
      let trainingCourseCategories =
        !!result && result.success ? result.data : [];
      let currentCategory = null;
      if (trainingCourseCategories.length > 0) {
        currentCategory = trainingCourseCategories[0];
      }
      defaultValues.trainingCourseCategory = !!currentCategory
        ? currentCategory.Id
        : null;

      return {
        defaultValues,
        courseTypeItems,
        termList,
        universityGroups,
        trainingCourseCategories,
      };
    },
    resetActiveQueryType() {
      let newQueryType = null;

      if (!!this.storeQueryType) {
        newQueryType = this.storeQueryType;
      } else {
        if (this.hasTab1) newQueryType = "1";
        else if (this.hasTab2) newQueryType = "2";
        else if (this.hasTab3) newQueryType = "3";
        else if (this.hasTab4) newQueryType = "4";
        this.updateQueryType(newQueryType);
      }

      this.activeQueryType = newQueryType;
    },
    onSaveAttendanceClick() {
      let signInQueryList1 =
        this.$vueRefStore.getChildrenRef("signInQueryList1");
      if (!!signInQueryList1) {
        let searchCondition = signInQueryList1.getSearchCondition();

        let termId =
          searchCondition.courseType ===
          this.GLOBAL.courseType.vocationalTraining
            ? searchCondition.trainingTermId
            : searchCondition.termId;
        let groupNumber =
          searchCondition.courseType ===
          this.GLOBAL.courseType.vocationalTraining
            ? null
            : searchCondition.groupNumber;
        this.$nextTick(async () => {
          this.isSaveStudentCourseAttendanceHistoryForAll = true;
          await saveStudentCourseAttendanceHistoryForAll(termId, groupNumber);
          this.isSaveStudentCourseAttendanceHistoryForAll = false;
          this.$message.success("提取出勤率成功");

          signInQueryList1.loadSignInQueryListByStudentFromServer();
        });
      }
    },
    onExportClick() {
      this.$nextTick(async () => {
        let showNotification = false;
        let exportFunc = null;
        switch (this.activeQueryType) {
          case "1": {
            let signInQueryList1 =
              this.$vueRefStore.getChildrenRef("signInQueryList1");
            if (!!signInQueryList1) {
              if (signInQueryList1.canExport) {
                exportFunc = signInQueryList1.exportSignInQueryListFromServer;
              } else {
                showNotification = true;
              }
            }
            break;
          }
          case "2": {
            let signInQueryList2 =
              this.$vueRefStore.getChildrenRef("signInQueryList2");
            if (!!signInQueryList2) {
              if (signInQueryList2.canExport) {
                exportFunc = signInQueryList2.exportSignInQueryListFromServer;
              } else {
                showNotification = true;
              }
            }
            break;
          }
          case "3": {
            let signInQueryList3 =
              this.$vueRefStore.getChildrenRef("signInQueryList3");
            if (!!signInQueryList3) {
              if (signInQueryList3.canExport) {
                exportFunc = signInQueryList3.exportSignInQueryListFromServer;
              } else {
                showNotification = true;
              }
            }
            break;
          }
          case "4": {
            let signInQueryList4 =
              this.$vueRefStore.getChildrenRef("signInQueryList4");
            if (!!signInQueryList4) {
              if (signInQueryList4.canExport) {
                exportFunc = signInQueryList4.exportSignInQueryListFromServer;
              } else {
                showNotification = true;
              }
            }
            break;
          }
        }

        if (!!exportFunc) {
          this.isExporting = true;

          await exportFunc();
          this.isExporting = false;
        }

        if (showNotification) {
          this.$notify({
            title: "提示",
            message: "表数据未加载",
            showClose: false,
            duration: 5000,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* elementui 的tabs组件出现蓝色边框问题 */

.el-tabs__item:focus.is-active.is-focus:not(:active) {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/page/admin/signInQuery.vue